import { useState, useEffect, useCallback} from 'react';
import { Link } from 'react-router-dom';
import './NumberGuessing.css';

const NumberGuessing = () => {
  const [targetNumber, setTargetNumber] = useState(0);
  const [guess, setGuess] = useState('');
  const [attempts, setAttempts] = useState(0);
  const [message, setMessage] = useState('');
  const [gameWon, setGameWon] = useState(false);
  const [guessHistory, setGuessHistory] = useState([]);

  const generateNewNumber = () => {
    return Math.floor(Math.random() * 100) + 1;
  };

  const startNewGame = useCallback(() => {
    setTargetNumber(generateNewNumber());
    setGuess('');
    setAttempts(0);
    setMessage('I\'m thinking of a number between 1 and 100. Can you guess it?');
    setGameWon(false);
    setGuessHistory([]);
  }, []);

  useEffect(() => {
    startNewGame();
  }, [startNewGame]);

  const handleGuess = () => {
    const numGuess = parseInt(guess);
    
    if (isNaN(numGuess) || numGuess < 1 || numGuess > 100) {
      setMessage('Please enter a valid number between 1 and 100!');
      return;
    }

    const newAttempts = attempts + 1;
    setAttempts(newAttempts);
    
    const historyEntry = {
      guess: numGuess,
      attempt: newAttempts
    };

    if (numGuess === targetNumber) {
      setMessage(`🎉 Congratulations! You guessed it in ${newAttempts} attempts!`);
      setGameWon(true);
      setGuessHistory(prev => [...prev, { ...historyEntry, result: 'correct' }]);
    } else if (numGuess < targetNumber) {
      setMessage('📈 Too low! Try a higher number.');
      setGuessHistory(prev => [...prev, { ...historyEntry, result: 'low' }]);
    } else {
      setMessage('📉 Too high! Try a lower number.');
      setGuessHistory(prev => [...prev, { ...historyEntry, result: 'high' }]);
    }
    
    setGuess('');
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !gameWon) {
      handleGuess();
    }
  };

  return (
    <div className="game-container">
      <div className="game-header">
        <h1 className="game-title-header">🎯 Number Guessing Game</h1>
        <div className="game-instructions">
          I'm thinking of a number between 1 and 100. Try to guess it in as few attempts as possible!
        </div>
      </div>

      <div className="game-board">
        <div className="score-display">
          Attempts: {attempts}
        </div>
        
        <div className="guessing-area">
          <div className="message">{message}</div>
          
          {!gameWon && (
            <div className="input-area">
              <input
                type="number"
                value={guess}
                onChange={(e) => setGuess(e.target.value)}
                onKeyPress={handleKeyPress}
                placeholder="Enter your guess"
                min="1"
                max="100"
                className="guess-input"
              />
              <button 
                className="btn btn-primary"
                onClick={handleGuess}
                disabled={!guess}
              >
                Guess!
              </button>
            </div>
          )}

          {guessHistory.length > 0 && (
            <div className="history">
              <h3>Your Guesses:</h3>
              <div className="history-list">
                {guessHistory.map((entry, index) => (
                  <div key={index} className={`history-item ${entry.result}`}>
                    #{entry.attempt}: {entry.guess} 
                    {entry.result === 'low' && ' (too low)'}
                    {entry.result === 'high' && ' (too high)'}
                    {entry.result === 'correct' && ' ✓'}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className="game-controls">
          <button className="btn btn-success" onClick={startNewGame}>
            New Game
          </button>
          <Link to="/" className="btn btn-secondary">
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NumberGuessing;